<div class="div-container" fxLayout="column" fxLayoutGap="20px">
  <span
    dir="auto"
    fxLayout="row"
    fxLayoutAlign="space-between"
    fxLayoutGap="40px"
  >
    <span dir="auto" class="heading medium" ngClass.xs="heading xs medium">{{
      title
    }}</span>
    <img
      alt="close"
      style="cursor: pointer; padding-top: 3px"
      (click)="onClose()"
      height="22"
      width="22"
      src="assets/icons/dialogclose.svg"
    />
  </span>
  <!-- Content Section Starts -->
  <mat-dialog-content *ngIf="!isNext">
    <div class="content regular" ngClass.xs="content xs regular">
      <div dir="auto">
        {{ "health_instructions_header" | transloco }}
      </div>
      <div dir="auto" style="text-align: justify">
        <ul fxLayoutGap="5px">
          <li class="text" dir="auto">
            {{ "health_instructions_1" | transloco }}
          </li>

          <li class="text" dir="auto">
            {{ "health_instructions_2" | transloco }}
          </li>

          <li class="text" dir="auto">
            {{ "health_instructions_3" | transloco }}
          </li>

          <li class="text" dir="auto">
            {{ "health_instructions_4" | transloco }}
          </li>

          <li class="text" dir="auto">
            {{ "health_instructions_5" | transloco }}
          </li>

          <li class="text" dir="auto">
            {{ "health_instructions_6" | transloco }}
          </li>
        </ul>
      </div>
      <div dir="auto" fxLayout="column" fxLayoutGap="20px">
        <div dir="auto">
          {{ "health_instructions_footer" | transloco }}
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-content *ngIf="isNext">
    <div class="content regular" ngClass.xs="content xs regular">
      <img
        fxHide.xs="true"
        (load)="setLoaded()"
        alt="covid life saving rules"
        [src]="desktopImage"
        width="100%"
        height="100%"
      />
      <img
        fxHide.xs="false"
        (load)="setLoaded()"
        fxHide="true"
        alt="covid life saving rules"
        [src]="mobileImage"
        width="100%"
        height="100%"
      />
    </div>
    <div
      *ngIf="imageLoading"
      fxLayout="column"
      fxLayoutAlign="center center"
      style="width: 600px; height: 350px"
      ngStyle.xs="width: 240px; height: 300px"
    >
      <mat-spinner
        diameter="35"
        mode="indeterminate"
        color="primary"
      ></mat-spinner>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div fxFlex fxLayout="column" fxLayoutGap="20px">
      <div dir="auto" class="content medium" *ngIf="!isNext">
        {{ "health_instructions_footer_1" | transloco }}
      </div>
      <div dir="auto" class="acknowledge-text medium" *ngIf="isNext">
        {{ "health_instructions_footer_2" | transloco }}
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button
          *ngIf="!isNext"
          mat-flat-button
          color="primary"
          class="btn-next"
          (click)="onNext()"
        >
          {{ "next" | transloco }}
        </button>
        <button
          dir="auto"
          *ngIf="isNext"
          mat-flat-button
          color="primary"
          class="btn-next"
          (click)="onSubmit()"
        >
          {{ "submit_health_instructions" | transloco }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
